import styled from 'styled-components'
import { Text1 } from '../../../ui/text'
import { FixedBottomButtonContainer, ScreenContainer as BaseScreenContainer } from '../styled'

export const ScreenContainer = styled(BaseScreenContainer).attrs({
	$fullHeight: true,
	$alignItems: 'center',
	$justifyContent: ' flex-start',
	$textAlign: 'center',
	$gap: '20px',
	$mobilePadding: '80px 10px 10px 10px'
})``

export const ExperienceTitle = styled(Text1)`
	margin-bottom: 16px;
`

export const ButtonContainer = styled(FixedBottomButtonContainer)`
	align-self: stretch;
	display: flex;
	justify-content: center;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		> button {
			max-width: 100%;
		}
	}
`
